import { Context } from "@nuxt/types";

import { type GiftGuideSubType, type LocalizedCategoriesResponse } from "@/store/gift-guides/types";
import {
  type ManyProductSetProductsResponse,
  type ManyProductSetsResponse,
  type ProductSetResponse,
} from "@/store/product-sets/types";
import Api from "@/utils/api";

const DEFAULT_ITEM_LIMIT = 36;

export default class ProductSetsApi extends Api {
  constructor($axios: Context["$axios"]) {
    super("productSetService", $axios);
  }

  async getProductSetInfo({ id }: { id: string }) {
    return await this.request<ProductSetResponse>({
      method: "GET",
      url: "/shop_product/get_shop_product_collection",
      params: {
        collection_id: id,
      },
    });
  }

  async getProductSetsByProfile({
    profileId,
    subtype,
    limit = DEFAULT_ITEM_LIMIT,
    next,
  }: {
    profileId: string;
    subtype?: GiftGuideSubType;
    limit?: number;
    next?: string;
  }) {
    return await this.request<ManyProductSetsResponse>({
      method: "GET",
      url: "/shop_product/get_shop_product_collections",
      params: {
        profile_id: profileId,
        subtype,
        limit,
        next,
      },
    });
  }

  async getProductSetProducts({ id, limit = DEFAULT_ITEM_LIMIT, next }: { id: string; limit?: number; next?: string }) {
    return await this.request<ManyProductSetProductsResponse>({
      method: "GET",
      url: "/shop_product/get_shop_products_by_collection",
      params: {
        collection_id: id,
        "includes[]": "product_details",
        limit,
        next,
      },
    });
  }

  async getLocalizedCategories(locale: string) {
    return await this.request<LocalizedCategoriesResponse>({
      method: "GET",
      url: "/gift_guide/get_localized_categories",
      headers: {
        // Override with only the user's selected language. The backend at the time of writing
        // doesn't support the accept-language spec, so we cannot format with the browser/requst values.
        // This value is also expected to be a locale ISO code (en-US, or zh-Hant), and not just a language.
        // The defined ISO codes should exist in nuxt-i18n's localeProperties oblect, as defined from the
        // locale files config. Should this change, a different form of mapping the current language to a ISO code
        // will be needed, or hopefully, the BE will be able to handle locale parsing.
        "Accept-Language": locale,
      },
    });
  }
}
